import { render, staticRenderFns } from "./ProposalPreviewCladify.vue?vue&type=template&id=0ae88f9a&scoped=true"
import script from "./ProposalPreviewCladify.vue?vue&type=script&lang=js"
export * from "./ProposalPreviewCladify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae88f9a",
  null
  
)

export default component.exports